import angular from 'angular';
import {
  loaderService,
  pmDataService,
  pmSharedModelService,
  ssDialogService,
} from 'app/services';

import editSectionDialog from '../../activeDocument/section/dialog.editSectionDialog';
import materialChangeDialog from '../../dialog.materialChangeDialog';
import endnoteTagMessagesTpl from './endnote.tag.messages.html';
import referenceSections from './reference-sections.directive';
import referenceSectionsController from './reference-sections.controller';
import validator, { name as validatorName } from './unique-endnote-tag.validator.directive';
import requiredMessagesTpl from './required.messages.html';
import controller from './edit-endnote-dialog.controller';
import template from './edit-endnote-dialog.html';

class dialogService {
  getOptions($event, { endnote, permissions, policyDocumentId, }) {
    return {
      controller,
      controllerAs: 'editEndnoteDialogVM',
      locals: {
        endnote,
        permissions,
        policyDocumentId,
      },
      bindToController: true,
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.pm.editEndnoteDialog', [
  editSectionDialog,
  loaderService,
  pmDataService,
  pmSharedModelService,
  ssDialogService,
  materialChangeDialog,
])
  .directive(validatorName, validator)
  .controller('ReferenceSectionsController', referenceSectionsController)
  .directive('pmReferenceSections', referenceSections)
  .service('editEndnoteDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('endnote.tag.messages.html', endnoteTagMessagesTpl);
    $templateCache.put('required.messages.html', requiredMessagesTpl);
  })
  .name;
